<template>
  <div class="base-scrollbar">
    <el-scrollbar class="list-scrollbar" :style="scrollbarStyle" @end-reached="handleEnd">
      <div class="list-container" :style="containerStyle">
        <slot></slot>
      </div>
    </el-scrollbar>
  </div>
</template>

<script setup lang="ts">
  import { type ScrollbarDirection } from 'element-plus';
  import { computed } from 'vue';

  interface Props {
    itemGap?: number;
    scrollbarOffset?: number;
  }

  const props = withDefaults(defineProps<Props>(), {
    itemGap: 10,
    scrollbarOffset: 0
  });

  const emit = defineEmits<{
    endReached: [direction: ScrollbarDirection];
  }>();

  const scrollbarStyle = computed(() => {
    return {
      width: `calc(100% + ${props.scrollbarOffset}px)`,
      'padding-right': `${props.scrollbarOffset}px`
    };
  });

  const containerStyle = computed(() => {
    return {
      gap: `${props.itemGap}px`
    };
  });

  function handleEnd(direction: ScrollbarDirection) {
    emit('endReached', direction);
  }
</script>

<style scoped>
  .base-scrollbar {
    width: 100%;
    height: 100%;
  }
  .list-scrollbar {
    box-sizing: border-box;
  }

  .list-container {
    width: 100%;
    height: auto;
    display: flex;
    flex-wrap: wrap;
  }
</style>
